// extracted by mini-css-extract-plugin
export default {"container":"SidePanelBox_container__8Wyq2"};